// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3N4AE","question":"Question_question__1G4yv","description":"Question_description__1FFpo"};